import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sage-crm-dev',
  templateUrl: './sage-crm-dev.component.html',
  styleUrls: ['./sage-crm-dev.component.css']
})
export class SageCrmDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/sage-crm-dev/sage-crm-dev.component.ts